import React from "react";
import * as S from "./styles";
import { withRouter, useHistory } from "react-router-dom";
import { Typography } from "@material-ui/core";
import ThemeButton from "../../components/ThemeButton";

function PackageUnavailable() {
	const history = useHistory();

	return (
		<S.Wrapper>
			<Typography variant="h3">Não foi possível confirmar este pacote.</Typography>
			<Typography variant="span">
				Um ou mais serviços não estão mais disponíveis no fornecedor.
			</Typography>
			<Typography variant="span">
				Escolha outra opção ou entre em contato com o nosso time de atendimento.
			</Typography>
			<ThemeButton
				onClick={() => history.push("/busca/resultado-pesquisa")}
				className="pesquisa"
			>
				Voltar para pesquisa
			</ThemeButton>
		</S.Wrapper>
	);
}

export default withRouter(PackageUnavailable);
